'use client';

import { useRouter } from '@contexts/Router/RouterContext';
import { useCountdown } from '@lib/hooks/useCountdown';
import {
  Announcement,
  AnnouncementBarMicrocopy,
} from '@lib/types/cms/AnnouncementBar';
import { Duration, isPast } from 'date-fns';
import { AnnouncementBar } from 'ui-components';
import { DEFAULT_LOCALE, pluralize } from 'utils';

const useFormatCountdown = (
  locale: string,
  countdownDuration: Duration | null,
  microcopy: AnnouncementBarMicrocopy,
  announcement?: Announcement | null
) => {
  if (
    !countdownDuration ||
    !announcement?.countdown ||
    isPast(announcement.countdown)
  ) {
    return null;
  }

  const days = countdownDuration.days ?? 0;
  const hours = countdownDuration.hours ?? 0;
  // Add 1 minute since we don't show seconds, keeps the countdown from showing 0 minutes
  const minutes = (countdownDuration.minutes ?? 0) + 1;
  let countdown = '';
  countdown += `${days} ${pluralize('day', microcopy, days, locale)} `;
  countdown += `${hours} ${pluralize('hour', microcopy, hours, locale)} `;
  countdown += `${minutes} ${pluralize('minute', microcopy, minutes, locale)} `;
  countdown += ` ${microcopy.left}`;
  return countdown;
};

export type AnnouncementBarWrapperProps = {
  data?: Announcement | null;
  microcopy: AnnouncementBarMicrocopy;
};

export const AnnouncementBarWrapper = ({
  data: announcement,
  microcopy,
}: AnnouncementBarWrapperProps) => {
  const router = useRouter();
  const { locale } = router;
  const countdownDuration = useCountdown(announcement?.countdown);

  const countdown = useFormatCountdown(
    locale ?? DEFAULT_LOCALE,
    countdownDuration,
    microcopy,
    announcement
  );

  return (
    <AnnouncementBar
      data={{
        html: announcement?.content?.html ?? '',
        countdown,
        destinationUrl: announcement?.destinationUrl,
      }}
    />
  );
};
